export default {
	// API_URL: 'https://linebotbe-production.up.railway.app/api/',
	// URL: 'https://linebotbe-production.up.railway.app/'
	API_URL: 'https://techbim.vn/api/',
	URL: 'https://techbim.vn/',
	DOMAIN_CLIENT: 'https://techbim.vn', // HomeTopBar and UserSidebar
}
